{
  "es": {
    "installment": {
      "actions": {
        "bulkEdit": {
          "detail": "Editar detalles",
          "reminder": "Editar recordatorios"
        },
        "closeAllRows": "Cerrar todas las filas",
        "deleteCount": "Estás a punto de eliminar {count} cuota. ¿Estás seguro? | Estás a punto de eliminar {count} cuotas. ¿Estás seguro?",
        "delete_installments": "Eliminar cuota | Eliminar cuotas",
        "edit": "Editar",
        "newInstallment": "Nuevo grupo de cuotas",
        "openAllRows": "Abrir todas las filas",
        "publish": "Publicar",
        "publishCustomer": "Publicar...",
        "save": "Actualizar",
        "unpublish": "Despublicar",
        "updateStatus": "Actualizar estado",
        "uploadInvoice": "Subir factura"
      },
      "attributes": {
        "amount": "Importe",
        "customer": "Cliente",
        "description": "Descripción",
        "due_date": "Fecha límite",
        "group_name": "Grupo de cuotas",
        "paid_at": "Pagado el",
        "status_deadline": "Estado",
        "unit": "Unidad"
      },
      "edit_actions": {
        "edit_amount": "Importes",
        "edit_deadline": "Fecha límite",
        "edit_description": "Descripción",
        "edit_status": "Estado"
      },
      "labels": {
        "cantEditFractions": "Establece el estado de la cuota en 'Borrador' para editar las reglas.",
        "changeStatusRequested": "Cambiar las cuotas del estado 'Borrador' a 'Facturada'",
        "changeVisibility": "Cambiar visibilidad...",
        "change_amounts": "Cambiar importes",
        "clear_due_date": "Limpiar la fecha límite de todas las cuotas seleccionadas",
        "clear_paid_at": "Limpiar la fecha de pago de todas las cuotas seleccionadas",
        "countEdit": "Editar cuota para 1 unidad | Editar cuota para {count} unidades",
        "created_at": "Creado el {created_at}",
        "deleteExplanation": "Todas las cuotas y facturas se eliminarán permanentemente de la plataforma.",
        "deleteExplanationGroup": "Como quieres eliminar todas las cuotas de este grupo de cuotas, el grupo de cuotas también se eliminará.",
        "details": "Detalles",
        "edit": "Editar cuotas",
        "editDueDate": "Editar fecha límite",
        "editInstallmentTerm": "Editar cuota",
        "excl_vat": "IVA excl.",
        "giveNewAmount": "Introducir nuevo importe",
        "goToUnitInstallments": "Ir a las cuotas de la unidad",
        "installmentNoteExplainer": "Esta nota solo es visible para los miembros del equipo.",
        "installment_categories": "Categorías personalizadas",
        "invoices": "1 factura | {count} facturas",
        "new_installment_fraction_category": "Categoría",
        "noDeadline": "Sin fecha límite",
        "notPublished": "No publicada",
        "paid": "Pagada",
        "published": "Publicada",
        "publishedCustomer": "Publicada para el cliente",
        "publishingForCustomers": "¿Estás seguro?",
        "selectOne": "Selecciona al menos 1 cuota",
        "selected": "{selected} cuota seleccionada. | {selected} cuotas seleccionadas.",
        "setDueDate": "Establecer fecha límite",
        "statusExplained": "¿Qué significa cada estado de las cuotas?",
        "status_click_to_change": "Haz clic para cambiar",
        "status_deadline": "Estado",
        "statuses": {
          "draft": "Borrador",
          "expected": "Prevista",
          "overdue": "Vencida",
          "paid": "Pagada",
          "requested": "Facturada"
        },
        "toBePaid": "Por pagar",
        "total": "Total",
        "unitInstallmentsWillBeShownHere": "Las cuotas de la unidad se mostrarán aquí",
        "unpublishingForCustomers": "Vas a despublicar las cuotas para el cliente. ¿Estás seguro?",
        "updateStatusCount": "Actualizar estado de 1 cuota | Actualizar estado de {count} cuotas",
        "uploadInvoiceCount": "Subir factura de 1 cuota | Subir factura de {count} cuotas",
        "uploadInvoiceUnit": "Subir factura a {unit_name}",
        "vat": "IVA",
        "vat_with_percentage": "{percentage}% IVA",
        "view_list": "Lista"
      },
      "legend": {
        "installmentDraft": "Cuota en borrador",
        "installmentDraftAfterDueDate": "Cuota en borrador",
        "installmentExpired": "Fecha límite vencida",
        "installmentPaid": "Cuota ya pagada",
        "installmentPaidAfterDue": "Cuota pagada después de la fecha límite",
        "installmentRequested": "Facturada",
        "reminders": {
          "active": "Se ha configurado al menos 1 recordatorio",
          "none": "No se ha configurado ningún recordatorio"
        }
      },
      "placeholders": {
        "customers": {
          "documents": {
            "subtitle": "Aquí se mostrarán todos los documentos de las cuotas.",
            "title": "¡Todavía no hay documentos!"
          },
          "new": {
            "subtitle": "¡Pronto habrá nuevas cuotas!"
          }
        }
      },
      "sort_options": {
        "due_date": "Fecha límite",
        "due_date asc": "Fecha límite más próxima primero",
        "due_date desc": "Fecha límite más lejana primero",
        "group_name": "Nombre",
        "group_name asc": "Nombre A-Z",
        "group_name desc": "Nombre Z-A",
        "status": "Estado",
        "status asc": "Estado A-Z",
        "status desc": "Estado Z-A",
        "updated_at asc": "Actualización más antigua primero",
        "updated_at desc": "Actualización más reciente primero"
      },
      "validation": {
        "needNumber": "Se necesita un número (p. ej. 8400,5)"
      }
    }
  }
}
